const xenditCountryCodes = ['ID', 'PH', 'VN']

export function isPaymentUsingXendit(countryCode) {
    return xenditCountryCodes.includes(countryCode)
}